import React, { useState, useEffect } from 'react';
import { format, toZonedTime,fromZonedTime } from 'date-fns-tz';
import { Grid, Paper, Typography } from '@mui/material';

const cities = [
    { name: "UTC", timeZone: "UTC" },
    { name: "Local", timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }, 
    { name: "Auckland", timeZone: "Pacific/Auckland" }, 
    { name: "Beijing", timeZone: "Asia/Shanghai" }, 
    { name: "New York", timeZone: "America/New_York" },
    { name: "London", timeZone: "Europe/London" },
    { name: "Tokyo", timeZone: "Asia/Tokyo" },
    { name: "Sydney", timeZone: "Australia/Sydney" },
    { name: "Paris", timeZone: "Europe/Paris" },
    { name: "Dubai", timeZone: "Asia/Dubai" },
    { name: "Moscow", timeZone: "Europe/Moscow" },
    // Add more cities as needed
];

function WorldClock() {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    // Helper function to determine the UTC offset and DST status
    const getTimeZoneDetails = (time: Date, timeZone: string) => {
      const localTime = toZonedTime(time, timeZone);
      const utcTime = fromZonedTime(localTime, timeZone);
      const offset = (localTime.getTime() - utcTime.getTime()) / 3600000 + 12; // Convert ms to hours
      const offsetSign = offset >= 0 ? '+' : '';
      const offsetString = `UTC ${offsetSign}${offset.toFixed(2)}`;

      // Check for DST by comparing January and June offsets
      const jan = new Date(new Date().getFullYear(), 0, 1); // January 1
      const jun = new Date(new Date().getFullYear(), 5, 1); // June 1
      const offsetJan = new Date(fromZonedTime(jan, timeZone)).getTimezoneOffset();
      const offsetJun = new Date(fromZonedTime(jun, timeZone)).getTimezoneOffset();
      const isDST = offsetJan !== offsetJun && new Date().getTimezoneOffset() === offsetJun;

      return { offsetString, isDST };
    };

    return (
      <Grid container spacing={2}>
        {cities.map((city) => (
          <Grid item xs={12} sm={6} md={4} key={city.name}>
            <Paper elevation={3} sx={{ padding: 2 }}>
              <Typography variant='h6' component='h3'>
                {city.name}
              </Typography>
              <Typography variant='body1'>
                {format(toZonedTime(currentTime, city.timeZone), 'HH:mm:ss', {
                  timeZone: city.timeZone,
                })}
              </Typography>
              <Typography variant='body2'>
                {getTimeZoneDetails(currentTime, city.timeZone).offsetString}
              </Typography>
              {/* <Typography variant='body2'>
                {getTimeZoneDetails(currentTime, city.timeZone).isDST ? 'Daylight Saving Time' : ''}
              </Typography> */}
            </Paper>
          </Grid>
        ))}
      </Grid>
    );
}

export default WorldClock;
